/*!
 * Copyright © 2019-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { TooltipModule } from 'shared';
import { VirtualScrollViewportResizeModule } from '../shared';
import { HierarchyTreeComponent } from './hierarchy-tree.component';

@NgModule({
  imports: [
    CdkTreeModule,
    CommonModule,
    MatLegacyCheckboxModule,
    ScrollingModule,
    MatIconModule,
    TooltipModule,
    VirtualScrollViewportResizeModule
  ],
  declarations: [HierarchyTreeComponent],
  exports: [HierarchyTreeComponent]
})
export class HierarchyTreeModule {}
